import { Component, OnInit } from '@angular/core';
import { ContactService } from '../../services/contact.service';
import { Router } from '@angular/router';
import { AdvGrowlService } from 'primeng-advanced-growl';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  public email:string;
  public nombre:string;
  public telf:string;
  public text:string;
  public politic:boolean;
  public correoMail: string;
  public hrefMail:string;

  public modal1:boolean;
  public modal2:boolean;


  constructor(
    private _serviceContact: ContactService,
    private _growlService: AdvGrowlService,
    private translate: TranslateService

    ) {
    this.email='';
    this.nombre='';
    this.telf='';
    this.text='';
    this.politic=false;
    this.correoMail='crecemosjuntos@ence.es';

   }

  ngOnInit() {
  }

  public sendEmail(){
    if(this.politic){
      // Validar que los campos obligatorios estén completos
      if(!this.nombre || !this.email || !this.text){
        this._growlService.createWarningMessage(
          this.translate.get('ence.contact-validation-title')['value'] || 'Campos requeridos',
          this.translate.get('ence.contact-validation-message')['value'] || 'Por favor, completa todos los campos obligatorios'
        );
        return;
      }

      // Construir el cuerpo del email
      const emailBody = `
Nombre: ${this.nombre}
Email: ${this.email}
Teléfono: ${this.telf || 'No proporcionado'}

Mensaje:
${this.text}

---
Enviado desde el formulario de contacto web de ENCE
      `.trim();

      // Construir el enlace mailto
      const subject = encodeURIComponent('Contacto desde formulario web');
      const body = encodeURIComponent(emailBody);
      const mailtoLink = `mailto:${this.correoMail}?subject=${subject}&body=${body}`;

      // Abrir el cliente de correo
      window.location.href = mailtoLink;

      // Mostrar mensaje de confirmación
      this._growlService.createSuccessMessage(
        this.translate.get('ence.contact-email-response')['value'] || 'Email preparado',
        this.translate.get('ence.contact-email-sended')['value'] || 'Se ha abierto tu cliente de correo con el mensaje preparado'
      );

      // Limpiar el formulario después de enviar
      this.clearForm();
    }else{
      this._growlService.createInfoMessage(this.translate.get('ence.contact-accept')['value'], this.translate.get('ence.contact-info').toString());
    }
  }

  private clearForm(): void {
    this.nombre = '';
    this.email = '';
    this.telf = '';
    this.text = '';
    this.politic = false;
  }
   public loadModal(type){
    if(type===1){
      this.modal1=true;
      this.modal2=false;
    }else{
      this.modal1=false;
      this.modal2=true;
    }

  }

  // public loadModal(type){
  //   if(type===1){
  //     this.modal1=true;
  //     this.modal2=false;
  //   }else{
  //     this.modal1=false;
  //     this.modal2=true;
  //   }

  // }
}
